import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { createOption } from 'react-redux-app/lib/modules/form/utils/multiSelect';

import { getAllCountries } from '../../init/selectors/initData';

import { XCARD_STATUS_ACTIVE } from '../constants';


export const getXCard = state => _get(state, 'xcard.card');
export const getHasXCard = state => !!getXCard(state);
export const getIsCardCanBeOrdered = state => !getHasXCard(state);

export const getIsXCardActive = state => {
  const xCard = getXCard(state);
  return !!(xCard && xCard.status === XCARD_STATUS_ACTIVE);
};

const getFormSettings = state => _get(state, 'xcard.formSettings');
export const getIsXCardInitialized = state => !!getFormSettings(state);

const getAvailableCountries = state => _get(getFormSettings(state), 'availableCountries');
export const getAvailableCountriesOptions = createSelector(
  getAllCountries,
  getAvailableCountries,
  (allCountries, availableCountries) => (
    allCountries
      .filter(({ code }) => availableCountries.includes(code))
      .map(({ code, name }) => createOption(name, code))
  )
);

export const getCountryToPhoneCodeMap = state => _get(getFormSettings(state), 'countryToPhoneCodeMap');

const getErrors = state => _get(state, 'xcard.errors');
export const getLoadXCardError = state => _get(getErrors(state), 'loadXCardError');
export const getOrderXCardError = state => _get(getErrors(state), 'orderXCardError');
export const getRecheckXCardStatusError = state => (
  _get(getErrors(state), 'recheckXCardStatusError')
);
